module.exports = __webpack_public_path__ + "img/fill2.3edcb356.svg";